<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      title="查看固定资产"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
        >
          <el-tabs v-model="activeName">
            <el-tab-pane
              name="basicData"
              label="基础内容"
            >
              <div class="modal-box">
                <h3 class="modal-title">
                  基础信息
                </h3>
                <div class="modal-row-box">
                  <el-row :gutter="10">
                    <el-col :span="18">
                      <el-form-item label="资产名称">
                        <el-input
                          v-model="dialogViewForm.name"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="计量单位">
                        <el-input
                          v-model="dialogViewForm.unit"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="规格配置">
                        <el-input
                          v-model="dialogViewForm.configSpec"
                          type="textarea"
                          disabled
                          rows="3"
                          style="margin-top: -8px;"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item label="管理人员">
                        <el-input
                          v-model="dialogViewForm.managerName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="管理数量">
                        <el-input
                          v-model="dialogViewForm.manageNumber"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="借出数量">
                        <el-input
                          v-model="dialogViewForm.lentNumber"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="损坏遗失数量">
                        <el-input
                          v-model="dialogViewForm.damageNumber"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>

              <div class="modal-box">
                <h3 class="modal-title">
                  备注信息
                </h3>
                <div class="modal-row-box">
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <el-form-item prop="remark">
                        <el-input
                          v-model="dialogViewForm.remark"
                          type="textarea"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>

              <div class="modal-box">
                <h3 class="modal-title">
                  借用记录清单
                </h3>
                <div class="modal-row-box">
                  <el-table
                    :ref="fixedAssetBorrowTableList.tableKey"
                    :data="fixedAssetBorrowTableList.tableData"
                    border
                    fit
                    stripe
                    highlight-current-row
                    :header-cell-style="{background:'#0076ff'}"
                    style="width: 100%"
                  >
                    <el-table-column
                      fixed
                      label="序号"
                      align="center"
                      type="index"
                      width="55"
                      :index="fixedAssetBorrowTableListIndexMethod"
                    />
                    <el-table-column
                      v-for="(column, index) in fixedAssetBorrowTableList.tableColumns"
                      :key="index"
                      resizable
                      :width="column.width ? column.width : ''"
                      show-overflow-tooltip
                      :label="column.title"
                      :prop="column.prop"
                      header-align="center"
                      :align="column.align || ''"
                    >
                      <template slot-scope="scope">
                        {{ scope.row[column.prop] }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- 分页组件 -->
                  <pagination
                    :total="fixedAssetBorrowTableList.tableDataTotal"
                    :page.sync="fixedAssetBorrowTableList.tableQuery.page"
                    :limit.sync="fixedAssetBorrowTableList.tableQuery.limit"
                    @pagination="requestFixedAssetBorrowTableListData"
                  />
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane
              name="changeLogData"
              label="资产变更日志清单"
            >
              <div class="modal-box">
                <h3 class="modal-title">
                  变更日志清单
                </h3>
                <div class="modal-row-box">
                  <el-table
                    :ref="fixedAssetLogTableList.tableKey"
                    :data="fixedAssetLogTableList.tableData"
                    border
                    fit
                    stripe
                    highlight-current-row
                    :header-cell-style="{background:'#0076ff'}"
                    style="width: 100%"
                  >
                    <el-table-column
                      fixed
                      label="序号"
                      align="center"
                      type="index"
                      width="55"
                      :index="fixedAssetLogTableListIndexMethod"
                    />
                    <el-table-column
                      v-for="(column, index) in fixedAssetLogTableList.tableColumns"
                      :key="index"
                      resizable
                      :width="column.width ? column.width : ''"
                      show-overflow-tooltip
                      :label="column.title"
                      :prop="column.prop"
                      header-align="center"
                      :align="column.align || ''"
                    >
                      <template slot-scope="scope">
                        {{ scope.row[column.prop] }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- 分页组件 -->
                  <pagination
                    :total="fixedAssetLogTableList.tableDataTotal"
                    :page.sync="fixedAssetLogTableList.tableQuery.page"
                    :limit.sync="fixedAssetLogTableList.tableQuery.limit"
                    @pagination="requestFixedAssetLogTableListData"
                  />
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from "@/mixin/dialogDragMixin";
// 分页组件
import Pagination from '@/components/Pagination'
// API
import { initFixedAssetApi, listFixedAssetLogByPageApi, listFixedAssetBorrowByPageApi } from "@/api/fixedAsset";

export default {
  components: { Pagination },
  mixins: [dialogDragMixin],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogViewForm: {},
      activeName: '',
      // 固定资产借用记录分页列表
      fixedAssetBorrowTableList: {
        tableKey: 'fixed_asset_borrow_table',
        tableColumns: [
          { title: '借用人', prop: 'borrower', width: 100, align: 'center' },
          { title: '借用数量', prop: 'borrowNumber', width: 100, align: 'center' },
          { title: '借用日期', prop: 'borrowDateValue', width: 100, align: 'center' },
          { title: '归还日期', prop: 'returnDateValue', width: 100, align: 'center' },
          { title: '借用情况说明', prop: 'borrowRemark' },
          { title: '状态', prop: 'statusValue', width: 70, align: 'center' },
          { title: '更新时间', prop: 'updateTimeValue', width: 150, align: 'center' },
        ],
        // 查询条件对象
        tableQuery: {
          page: 1,
          limit: 20,
          // 查询条件
          search: {
            assetId: ''
          }
        },
        tableLoading: false,
        // Table 数据
        tableData: [],
        // Table 总数据条数
        tableDataTotal: 0
      },
      // 固定资产变更日志分页列表
      fixedAssetLogTableList: {
        tableKey: 'fixed_asset_log_table',
        tableColumns: [
          { title: '变更时间', prop: 'operateTimeValue', width: 150, align: 'center' },
          { title: '变更类型', prop: 'typeValue', width: 100, align: 'center' },
          { title: '变更日志说明', prop: 'content' },
          { title: '操作人', prop: 'operator', width: 100, align: 'center' },
        ],
        // 查询条件对象
        tableQuery: {
          page: 1,
          limit: 20,
          // 查询条件
          search: {
            assetId: ''
          }
        },
        tableLoading: false,
        // Table 数据
        tableData: [],
        // Table 总数据条数
        tableDataTotal: 0
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this;

        _this.loading = true;
        _this.dialogViewForm = {};
        _this.fixedAssetLogList = [];
        _this.activeName = 'basicData';
        _this.initFixedAssetData();
        // 获取借用记录分页列表数据
        _this.fixedAssetBorrowTableList.tableQuery.search.assetId = _this.dataId;
        _this.searchFixedAssetBorrowTableListData();
        // 获取操作日志分页列表数据
        _this.fixedAssetLogTableList.tableQuery.search.assetId = _this.dataId;
        _this.searchFixedAssetLogTableListData();
        _this.$nextTick(() => { });
      }
    }
  },
  methods: {
    // 加载数据
    initFixedAssetData() {
      let _this = this;
      initFixedAssetApi({ id: _this.dataId }).then(response => {
        _this.dialogViewForm = response.data || {};
        _this.loading = false;
      });
    },
    /* 固定资产借用记录分页列表 */
    fixedAssetBorrowTableListIndexMethod(index) {
      return index + 1 + (this.fixedAssetBorrowTableList.tableQuery.page - 1) * this.fixedAssetBorrowTableList.tableQuery.limit;
    },
    requestFixedAssetBorrowTableListData() {
      let _this = this;
      _this.fixedAssetBorrowTableList.tableLoading = true;
      listFixedAssetBorrowByPageApi({ condition: JSON.stringify(_this.fixedAssetBorrowTableList.tableQuery) }).then(response => {
        const { data } = response;
        _this.fixedAssetBorrowTableList.tableData = data.data || [];
        _this.fixedAssetBorrowTableList.tableDataTotal = data.recordsTotal || 0;
        _this.fixedAssetBorrowTableList.tableLoading = false;
      }).catch(() => { })
    },
    searchFixedAssetBorrowTableListData() {
      let _this = this;
      // 重置页码
      _this.fixedAssetBorrowTableList.tableQuery.page = 1;
      _this.fixedAssetBorrowTableList.tableQuery.limit = 20;
      _this.requestFixedAssetBorrowTableListData();
    },
    /* 固定资产变更日志分页列表 */
    fixedAssetLogTableListIndexMethod(index) {
      return index + 1 + (this.fixedAssetLogTableList.tableQuery.page - 1) * this.fixedAssetLogTableList.tableQuery.limit;
    },
    requestFixedAssetLogTableListData() {
      let _this = this;
      _this.fixedAssetLogTableList.tableLoading = true;
      listFixedAssetLogByPageApi({ condition: JSON.stringify(_this.fixedAssetLogTableList.tableQuery) }).then(response => {
        const { data } = response;
        _this.fixedAssetLogTableList.tableData = data.data || [];
        _this.fixedAssetLogTableList.tableDataTotal = data.recordsTotal || 0;
        _this.fixedAssetLogTableList.tableLoading = false;
      }).catch(() => { })
    },
    searchFixedAssetLogTableListData() {
      let _this = this;
      // 重置页码
      _this.fixedAssetLogTableList.tableQuery.page = 1;
      _this.fixedAssetLogTableList.tableQuery.limit = 50;
      _this.requestFixedAssetLogTableListData();
    },
    modalClose() {
      this.$emit("update:dialogVisible", false); // 直接修改父组件的属性
    },
  }
};
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
}
::v-deep .el-table {
  margin: 5px 0;
  th {
    color: #ffffff;
  }
  .cell {
    line-height: 16px;
  }
}
.pagination-container {
  padding: 0;
  margin: 2px;
}
::v-deep .el-pagination.is-background {
  .el-pager li {
    height: 20px;
    line-height: 20px;
    min-width: 22px;
  }
  .el-input--mini .el-input__inner {
    height: 20px;
    line-height: 20px;
  }
  .el-input--mini .el-input__icon {
    line-height: 20px;
  }
}
::v-deep .el-pagination button {
  height: 20px;
  line-height: 20px;
  min-width: 18px;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  line-height: 20px;
  height: 20px;
}
::v-deep .el-pagination span:not([class*='suffix']),
::v-deep .el-pagination button {
  height: 20px;
  line-height: 20px;
}
</style>
